module.exports = __webpack_public_path__ + "krecove-zily_4_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/obecna-a-zilni-chirurgie/krecove-zily_4_before_tn.jpg
// module id = 1500
// module chunks = 0